import BookingFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => <GenericCreateForm formLayoutComponent={<BookingFormLayout />} transformValues={transformValues} />
